<template>
  <div class="page_header" :style="cssVars">
    <div class="container">
      <div class="inner">
        <h1 v-if="title" v-html="title"></h1>

        <a
          v-if="parsedCta"
          :href="parsedCta.url"
          :title="parsedCta.title"
          :target="parsedCta.target"
          v-html="parsedCta.title"
        ></a>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {};
  },

  props: {
    title: {},
    cta: {},
    background_image: {},
  },

  computed: {
    cssVars() {
      return {
        '--background-image': 'url(' + this.parsedBackgroundImage.url + ')',
      };
    },

    parsedCta() {
      if (this.cta) {
        return JSON.parse(this.cta);
      } else {
        return null;
      }
    },

    parsedBackgroundImage() {
      if (this.background_image) {
        return JSON.parse(this.background_image);
      } else {
        return null;
      }
    },
  },

  watch: {},

  methods: {},

  components: {},

  created() {},
  mounted() {},
};
</script>

<style lang="scss" scoped>
@import '../../styles/common/variables';

.page_header {
  background-image: var(--background-image);
  background-size: cover;
  background-position: center center;
  background-repeat: no-repeat;
  padding: 80px 0;

  .inner {
    grid-column: span 12;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: flex-start;
    gap: 40px;
    min-height: 150px;

    @media (max-width: $mobile-xl) {
      align-items: center;
    }

    h1 {
      color: var(--white);
    }

    a {
      background: var(--orange);
      padding: 10px 40px;
      text-transform: uppercase;
      text-decoration: none;
      transition: 0.2s ease all;
      font-size: 20px;
      line-height: 30px;
      color: var(--white);

      &:hover {
        background: var(--purple);
        color: var(--white);
        transition: 0.2s ease all;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// resources/assets/scripts/vue/PageHeader.vue